import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { extendObservable } from 'mobx'
import PropTypes from 'prop-types'

import Spinner from '@components/spinner'
import NoContent from '@components/Error/NoContent'
import Pagination from '@components/Pagination/Pagination'
import Action from '@components/Action'
import DownloadIcon from '@components/Icon/Download'
import { StatusLabel } from '@components/StatusLabel'
import { tokenStorage, formatDate } from '@atheneum/api/dist/lib'

class Projects extends Component {
  constructor (props) {
    super(props)
    extendObservable(this, {
      page: 1,
      loading: true
    })
    this.loadProjects(props.contractStore.contract.id)
  }

  loadProjects = async (contractId, page = 1) => {
    await this.props.contractStore.getProjects(contractId, page, 10)
    this.page = page
    this.loading = false
  }

  onExportClick = () => {
    const { contract } = this.props.contractStore
    const token = tokenStorage.get()
    const url = `/api/contract/${contract.id}/projects?export=true&token=${token}`
    window.open(url)
  }

  render () {
    const { contract, projects, projectCount } = this.props.contractStore
    const { staticData } = this.props

    if (projectCount === 0) return <NoContent />
    if (this.loading) return <Spinner />

    return (
      <div>
        <div className='actions-wrapper actions-wrapper--space-between'>
          <ul className='actions'>
            <li>
              <Action onClick={this.onExportClick}>
                <DownloadIcon />
                <span>Export</span>
              </Action>
            </li>
          </ul>
        </div>
        <table className='table-wrapper invoice-table'>
          <thead>
            <tr className='title'>
              <th>Project name</th>
              <th>Subindustry</th>
              <th>Case code</th>
              <th>Status</th>
              <th>Start date</th>
              <th>End date</th>
              <th className='right-align'>Total</th>
            </tr>
          </thead>
          <tbody>
            {projects.map(project => (
              <ProjectRow
                key={project.id}
                project={project}
                contract={contract}
                staticData={staticData}
                sidebarStore={this.props.sidebarStore}
              />
            ))}
          </tbody>
        </table>
        <Pagination
          total={projectCount}
          perPage={10}
          maxPages={Math.ceil(projectCount / 10)}
          page={this.page}
          onChange={p => this.loadProjects(contract.id, p)}
        />
      </div>
    )
  }

  static propTypes = {
    contractStore: PropTypes.object,
    sidebarStore: PropTypes.object,
    staticData: PropTypes.object
  }
}

function ProjectRow ({ project, staticData, sidebarStore }) {
  const { subIndustries } = staticData.names

  return (
    <tr>
      <td>
        <span
          className='row--link'
          onClick={() => {
            sidebarStore.openSidebar({
              id: project.id,
              template: 'project'
            })
          }}
        >
          {project.projectName}
        </span>
      </td>
      <td>{subIndustries[project.subIndustryId]}</td>
      <td>{project.caseCode}</td>
      <td>
        <StatusLabel
          statusId={project.projectStatusId}
          statusesType='projectStatuses'
        />
      </td>
      <td>{formatDate(project.startDate)}</td>
      <td>{formatDate(project.endDate)}</td>
      <td className='right-align'>
        {project.creditsUsed ? project.creditsUsed + ' credits' : ''}
      </td>
    </tr>
  )
}

ProjectRow.propTypes = {
  project: PropTypes.object,
  staticData: PropTypes.object,
  sidebarStore: PropTypes.object
}

export default inject('staticData', 'sidebarStore')(observer(Projects))
